import { Engine } from './core/Engine';
import { HeightField } from './world/HeightField';
import { loadTerrainTextures } from './world/TerrainTextures';

/**
 * Bootstrap. Nejdřív se vygeneruje výšková mapa (ve workerech), teprve pak
 * vzniká renderer — díky tomu není na startu žádný zaseknutý snímek.
 */

const container = document.getElementById('app') as HTMLElement;
const loading = document.getElementById('loading') as HTMLElement;
const bar = document.querySelector('#bar > i') as HTMLElement;
const message = document.getElementById('loading-msg') as HTMLElement;

function progress(value: number, text: string): void {
  bar.style.width = `${Math.round(value * 100)}%`;
  message.textContent = text;
}

async function boot(): Promise<void> {
  progress(0.05, 'generuji výškovou mapu');
  const started = performance.now();

  const heightField = await HeightField.generate((t) => {
    progress(0.05 + t * 0.6, `generuji výškovou mapu · ${Math.round(t * 100)} %`);
  });
  const genMs = performance.now() - started;

  progress(0.7, 'načítám textury');
  const textures = await loadTerrainTextures((loaded, total) => {
    progress(0.7 + (loaded / total) * 0.15, `načítám textury · ${loaded}/${total}`);
  });

  progress(0.82, 'stavím terén');
  const engine = new Engine(container, heightField, textures);

  progress(0.90, 'načítám 3D postavu a animace');
  await engine.initCharacter();

  if (import.meta.env.DEV) {
    // Vývojové snímkování scény do .shots/ — viz src/dev/capture.ts.
    const { installCapture } = await import('./dev/capture');
    installCapture(engine);
    // Objektivní kontrola postavy na pixelech — window.auditCharacter().
    const { installMeshAudit } = await import('./dev/meshAudit');
    installMeshAudit(engine);
  }

  progress(0.96, 'kompiluji shadery');
  await engine.warmUp();

  progress(1, `hotovo za ${Math.round(performance.now() - started)} ms`);
  console.info(
    `[hra] výšková mapa ${heightField.res}x${heightField.res} za ${genMs.toFixed(0)} ms, ` +
      `chunků ${engine.terrain.stats.chunksTotal}`,
  );

  engine.start();
  loading.classList.add('hidden');

  // Pro ladění z konzole.
  const { captureFrame } = await import('./ui/capture');
  Object.assign(window, {
    engine,
    captureFrame,
    /**
     * Ladění meče z konzole:  mec({ rx: 1.57, grip: 1.2 })
     * Vrátí hodnoty ve tvaru, který stačí vložit do SWORD_FIT.
     */
    mec: (values: Record<string, number>) => engine.weapon?.tune(values) ?? 'meč zatím není',
  });
}

boot().catch((error: unknown) => {
  console.error(error);
  message.textContent = `chyba: ${error instanceof Error ? error.message : String(error)}`;
});
